import { render, staticRenderFns } from "./TrendingList.vue?vue&type=template&id=0aad036f&scoped=true&"
import script from "./TrendingList.vue?vue&type=script&lang=js&"
export * from "./TrendingList.vue?vue&type=script&lang=js&"
import style0 from "./TrendingList.vue?vue&type=style&index=0&id=0aad036f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aad036f",
  null
  
)

export default component.exports